<template>
    <div class="userOuter">
        <Header></Header>
        <div class="user">
            <div class="user_container">
                <div class="userLeft">
                    <ul>
                        <li v-for="(item, index) in lists" :key="index" 
                            :class="['item', item.showBorderLine ? 'borderLine':''
                                // item.showBorderLine && item.name === '意见反馈' ? 'borderLine_advice':''
                            ]" >
                            <div @click=showBorder(index)>
                                <router-link :to="item.path">
                                    <span>{{ item.name }}</span>
                                </router-link>
                            </div>
                        </li>
                    </ul>
                    <!-- <div></div> -->
                </div>
                <div class="userRight">
                    <div class="advice">
                        <!-- 修改信息 -->
                        <div class="advice_container change">
                            <span class="title">反馈类别</span>
                            <div class="category">
                                <el-button title="暂未开放" @click="chooseBug" :class="isBug ? 'active' : ''">BUG类型</el-button>
                                <el-button @click="chooseFeedback" :class="isFeedback ? 'active' : ''">反馈意见</el-button>
                            </div>
                            <div class="texture">
                                <span class="title">内容(必填)</span>
                                <el-input
                                    rows = 5
                                    maxlength="300"
                                    type="textarea"
                                    placeholder="请输入问题描述"
                                    v-model="textarea"
                                ></el-input>
                                <p class="question_p">请写15字以上的描述，以便我们更好的为您提供帮助。</p>
                            </div>
                            <div class="pic" v-if="isBug">
                                <el-upload
                                    class="avatar-uploader"
                                    :headers="uploadHeaders"
                                    :action="getNoSecretAction()"
                                    :data="{type: 'advice'}"
                                    :file-list="fileList"
                                    :limit = '15' :on-change="handleImageChange"
                                    :show-file-list="true" :on-exceed="handleExceed"
                                    :on-success="handleImageSuccess"
                                    :before-upload="beforeImageUpload">
                                    <i class="el-icon-upload"></i>
                                    <div class="el-upload__text"><em>点击上传</em></div>
                                    <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过10MB</div>
                                </el-upload>
                            </div>
                            <div class="line1">
                                <div class="tel">
                                    <span class="title">联系人(必填)</span>
                                    <el-input placeholder="请输入联系人姓名" v-model="name"></el-input>
                                </div>
                                <div class="tel tel_gap">
                                    <span class="title title-short">邮箱</span>
                                    <el-input placeholder="请输入联系邮箱" v-model="email"></el-input>
                                </div>
                            </div>
                            <div class="line2">
                                <div class="tel">
                                    <span class="title ">联系电话(必填)</span>
                                    <el-input placeholder="请输入联系电话号" v-model="phone"></el-input>
                                </div>
                                <div class="tel tel_gap">
                                    <span class="title title-short">单位</span>
                                    <el-input placeholder="请输入联系单位" v-model="unit"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="submit_area">
                            <el-button class="submit_Btn" @click="submitFeedback">
                                <span class="first-letter">提</span>
                                <span class="second-letter">交</span>
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "../../components/header/index.vue"
import { userMessage } from '../../util/index'
import { baseUrl } from "../../util/constant";

import { mapState } from 'vuex'
export default {
    data() {
        return {
            isBug: false,
            isFeedback: true,
            textarea: '',
            imageUrl: '',
            phone: '',
            name: '',
            email: '',
            unit: '',
            showBorderLine:false,
            fileList: [],
            lists:[
                {
                    id: 0,
                    path: '/advice',
                    name: '意见反馈',
                    showBorderLine:true
                },
            ]
        };
    },
    computed:{
        ...mapState(['userInformation']),
        uploadHeaders (){
            return {
                Authorization: window.localStorage.getItem('userToken')
            }
        }
    },
    components:{
        Header
    },
    methods:{
        getNoSecretAction() {
            return baseUrl + '/upload/image'
        },
        showBorder(i){
            // this.showBorderLine = true
            this.lists[i].showBorderLine = true
            // 其他的都为false
            this.lists.forEach((item,index)=>{
                if(index!=i){
                    item.showBorderLine = false
                }
            })
        },
        chooseBug(){
            this.isBug = true;
            this.isFeedback = false;
        },
        chooseFeedback(){
            this.isBug = false;
            this.isFeedback = true;
        },
        handleImageSuccess(res, file) {
            if(res.code === 200){
                this.fileList.push({
                    name: file.name,
                    url: res.data.fileUrl
                })
                // this.fileList.push(file)
            }else{
                this.$message.error(res.message)
            }
        },
        handleImageChange(){

        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeImageUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG 或者 PNG 格式!');
            }

            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return ( isJPG || isPNG) && isLt2M;
        },
        submitFeedback(){
            if(this.textarea == '' || this.phone == '' || this.name == ''){
                this.$message.error("请填写完整信息")
                return
            }
            if(this.textarea.length < 15){
                this.$message.error("反馈问题请输入至少15个字符")
                return
            }
            // 手机号验证
            const reg = /^1[3456789]\d{9}$/
            if(!reg.test(this.phone)){
                this.$message.error("请输入正确的手机号")
                return
            }
            // 邮箱验证
            if(this.email){
                const regEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
                if(!regEmail.test(this.email)){
                    this.$message.error("请输入正确的邮箱")
                    return
                }
            }
            let obj = {
                "type": 0,
                "content": this.textarea,
                "name": this.name,
                "phone": this.phone,
            }
            if(this.isBug) obj.type = 1
            if(this.fileList.length > 0) {
                let images = []
                this.fileList.forEach(item=>{
                    images.push(item.url)
                })
                obj.images = images
            }
            if(this.email) obj.email = this.email
            if(this.unit) obj.unit = this.unit
            let token = window.localStorage.getItem("userToken")
            userMessage(obj, token).then(res=>{
                if(res.code == 200){
                    this.$message.success("提交成功")
                    this.textarea = ''
                    this.name = ''
                    this.phone = ''
                    this.email = ''
                    this.unit = ''
                    this.fileList = []
                }else{
                    this.$message.error(res.message)
                }
            })
        }
    },
    created(){
        // const userToken = window.localStorage.getItem("userToken")
        // if(!userToken){
        //     this.$message.error("请先登录")
        //     this.$router.push("/")
        // }
        // 判断当前路由
        this.lists.forEach((item,index)=>{
            if(item.path==this.$route.path){
                item.showBorderLine = true
            }
        })
        console.log('当前路由', this.$route.path);
    }
}
</script>

<style scoped lang="less">
// 媒体查询
@media screen and (max-width: 1800px) {
    .user_container {
        width: 100%;
        // background-color: #54ceec;
    }
}
@media screen and (min-width: 1800px)  and (max-width: 2300px) {
    .user_container {
        width: 80%;
        // background-color: #54ec93;
    }
}
.userOuter{
    background-color: #E9E9EA;
    min-height: 100vh;
}
.user{
    // background-color: #E9E9EA;
    min-width: 1350px;
    // width: 100vw;
    // height: 100vh;
    .user_container {
        // width: 80%;
        padding-top: 3.06rem;
        margin: 0 auto;
        // background-color: aquamarine;
        display: flex;
        justify-content: center;

    }
}


.userLeft:hover{
    color: #54ceec;
}
.userLeft {
    /* width: 10%; */
    /* position: fixed; */
    height: 40%;
    // margin-right: 2rem;
    color: #999999;
    height: auto;
    padding-right: 1rem;
    ul{
        padding: 10px 0;
        border-radius: 10px;
        background-color: #ffffff;
    }
    .item{
        padding: 1rem 5.38rem 1rem 0;
        a{
            color: #999999;
        }
        a:hover{
            color: #54ceec;
        }
        span{
            // background-color: #999999;
            display: inline-block;
            padding-left: 1rem;
            // width: 4.5rem;
        }
    }
    .item:hover{
        color: #54ceec ;
    }
    .borderLine{
        span{
            // background-color: #999999;
            display: inline-block;
            padding-left: 1rem;
            color: #54ceec !important;
            // width: 4.5rem;
            border-left: 4px solid #54ceec;
        }
    }
    .advice {
        position: absolute;
        margin: 1.5rem 0 0 0;
        background-color: #ffffff;
        border-radius: 10px;
        // width: 100%;
        // height: 100%;
        // padding: 1rem 0 0 0;
    }
}

.userRight {
    width: 70%;
    max-width: 1400px;
    // height: 120vh;
    border-radius: 15px;
    background-color: #fff;
    .advice{
        padding-bottom: 3.38rem;
        padding: 3.5rem 5rem;
    .dialog_container{
        p{
            font-size: 1.5rem;
            text-align: center;
            letter-spacing: 5px;
            color: #000;
        }
    }
    .advice_container{
        // background-color: #cde5eb;
        .title{
            display: inline-block;
            padding: 0.5rem 0;
            color: #2c2c2c;
            min-width: 110px;
        }
        .title-short{
            min-width: 40px;
        }
        .category{
            ::v-deep .el-button{
                background-color: #e9e9e9;
                border: none;
                width: 6rem;
                margin: 1rem 2rem 1rem 0;
            }
            ::v-deep .el-button:hover{
                background-color: #54d1ef;
                color: #fff;
                border: none;
            }
            .active{
                background-color: #54d1ef;
                color: #fff;
            }
        }
        .pic{
            .avatar-uploader{
                background: #dddddd;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 2rem 20%;
            }
            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }
            ::v-deep .el-upload--text{
                padding: 1rem 3rem;
                border: 1px dashed #9f9f9f;
            }
            .el-upload__tip{
                text-align: center;
            }
            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }
        }
        .question_p{
            color: #d4d4d4;
            font-size: 14px;
            text-indent: 20px;
            margin-bottom: 1rem;
        }
        .line1, .line2{
            display: flex;
            align-items: center;
        }
        .tel{
            display: flex;
            align-items: center;
            margin-top: 1rem;
            ::v-deep .el-input{
                width: 15rem;
                margin-left: 5px;
            }
            ::v-deep .el-input__inner{
                border-bottom: 1px solid #d4d4d4;
                border-radius: 10px;
                height: 26px;
                line-height: 26px;
            }
            
        }
        .tel_gap{
            margin-left: 15%;
        }

    }
    .submit_area{
        display: flex;
        justify-content: center;
        ::v-deep .el-button{
            margin: 2rem 0 0;
            border: none;
            background-color: #e6e6e6;
            border-radius: 20px;
        }
        ::v-deep .el-button:hover{
            background-color: #54d1ef;
            color: #fff;
        }
        .submit_Btn{
            display: inline-flex;
            justify-content: center; /* 水平居中 */
            align-items: center;    /* 垂直居中 */
            position: relative;
        }
        .first-letter, .second-letter {
            margin: 0 15px; /* 调整间距 */
        }
    }
}
}
</style>
